const e={path:"/api/v1/wallets/revoke",method:"POST"};export{e as WalletsRevoke};
